export const SITE_THIRD_PARTY_SENSORS_COUNT_CARD_FRENCH_LOCALE = {
  title: "Capteurs",
  subtitle: "Sur site",
  seeMore: "Voir plus",
};
